export default {
    formId: 'cotizarForm',
    formField: {
        afinidad: {
            name: 'afinidad',
            label: 'Afinidad',
            requiredErrorMsg: 'Debe especificar la afinidad a la que pertenece el asegurado'
        },
        tamanioVivienda: {
            name: 'tamanioVivienda',
            label: 'Tamaño de vivienda *',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        tipoVivienda: {
            name: 'tipoVivienda',
            label: 'Tipo de vivienda *',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        codigosLocalidad: {
            name: 'codigosLocalidad',
            label: 'Código postal / Localidad',
            requiredErrorMsg: 'Debe completar este campo'
        },
        descuentoEspecial: {
            name: 'descuentoEspecial',
            label: 'Descuento especial',
            requiredErrorMsg: 'Debe completar este campo'
        },
        coberturas: {
            sumaAsegurada: {
                name: 'sumaAsegurada',
                label: 'Suma asegurada',
                requiredErrorMsg: 'Debe completar este campo'
            },
            numeroCobertura: {
                name: 'numeroCobertura',
                label: 'Número cobertura',
                requiredErrorMsg: 'Debe completar este campo'
            },
            selectedCobertura: {
                name: 'selectedCobertura',
            },
        },
        coberturasAdicionales: {
            sumaAseguradaAdicional: {
                name: 'sumaAsegurada',
                label: 'Suma asegurada',
                requiredErrorMsg: 'Debe completar este campo'
            },
            numeroCoberturaAdicional: {
                name: 'numeroCobertura',
                label: 'Número cobertura',
                requiredErrorMsg: 'Debe completar este campo'
            },
            selectedCoberturaAdicional: {
                name: 'selectedCoberturaAdicional',
            },
        },
        deducible: {
            name: 'deducible',
            label: 'Deducible',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        fechaCotizacion: {
            name: 'fechaCotizacion',
            label: 'Fecha de cotización*',
            requiredErrorMsg: 'Debe indicar la fecha de cotización'
        }
    }
};
